(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luvia-absorbency"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.LuviaReveal) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function count(el) {
      var end = parseFloat(el.getAttribute('data-lv-count')) || 0;
      if (reduce) { el.textContent = end; return; }
      var start = null, dur = 1300;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function show(el) { el.classList.add('is-visible'); el.querySelectorAll('[data-lv-count]').forEach(count); }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.18 }) : null;
    function scan(root) {
      (root || document).querySelectorAll('[data-lv-reveal]:not(.lv-ready)').forEach(function (el) {
        if (io && !reduce) { el.classList.add('lv-ready'); io.observe(el); } else { show(el); }
      });
    }
    window.LuviaReveal = { scan: scan };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  (function () {
    if (window.LuviaLayers) return;
    window.LuviaLayers = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      if (root.__lvInit) return;
      root.__lvInit = true;
      var sheets = root.querySelectorAll('.lv-lay__sheet');
      var items = root.querySelectorAll('.lv-lay__item');
      var btns = root.querySelectorAll('.lv-lay__btn');
      var current = 0, timer = null, userTouched = false;
      function set(i) {
        current = i;
        root.classList.add('has-active');
        sheets.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
        btns.forEach(function (b, k) { b.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      }
      function stop() { userTouched = true; if (timer) { clearInterval(timer); timer = null; } }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { stop(); set(parseInt(b.getAttribute('data-index'), 10)); });
        b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { stop(); set(parseInt(b.getAttribute('data-index'), 10)); } });
      });
      if (!reduce && sheets.length > 1 && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !userTouched && !timer) {
              timer = setInterval(function () { set((current + 1) % sheets.length); }, 3600);
            } else if (!en.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.4 }).observe(root);
      }
      set(0);
    }
    function scan(r) { (r || document).querySelectorAll('[data-lv-layers]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-lv-layers]');
      if (!root) return;
      var btn = e.target.querySelector('.lv-lay__btn');
      if (btn) btn.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luvia-honest-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.LuviaReveal) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function count(el) {
      var end = parseFloat(el.getAttribute('data-lv-count')) || 0;
      if (reduce) { el.textContent = end; return; }
      var start = null, dur = 1300;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function show(el) { el.classList.add('is-visible'); el.querySelectorAll('[data-lv-count]').forEach(count); }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.18 }) : null;
    function scan(root) {
      (root || document).querySelectorAll('[data-lv-reveal]:not(.lv-ready)').forEach(function (el) {
        if (io && !reduce) { el.classList.add('lv-ready'); io.observe(el); } else { show(el); }
      });
    }
    window.LuviaReveal = { scan: scan };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  (function () {
    if (window.LuviaFaq) return;
    window.LuviaFaq = true;
    function toggle(item, open) {
      var btn = item.querySelector('.lv-faq__q button');
      item.classList.toggle('is-open', open);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-lv-faq] .lv-faq__q button');
      if (!btn) return;
      var item = btn.closest('.lv-faq__item');
      var root = btn.closest('[data-lv-faq]');
      var willOpen = !item.classList.contains('is-open');
      root.querySelectorAll('.lv-faq__item.is-open').forEach(function (it) { if (it !== item) toggle(it, false); });
      toggle(item, willOpen);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target.closest && e.target.closest('[data-lv-faq] .lv-faq__item');
      if (item) toggle(item, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luvia-honest-math"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.LuviaReveal) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function count(el) {
      var end = parseFloat(el.getAttribute('data-lv-count')) || 0;
      if (reduce) { el.textContent = end; return; }
      var start = null, dur = 1300;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function show(el) { el.classList.add('is-visible'); el.querySelectorAll('[data-lv-count]').forEach(count); }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.18 }) : null;
    function scan(root) {
      (root || document).querySelectorAll('[data-lv-reveal]:not(.lv-ready)').forEach(function (el) {
        if (io && !reduce) { el.classList.add('lv-ready'); io.observe(el); } else { show(el); }
      });
    }
    window.LuviaReveal = { scan: scan };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  (function () {
    if (window.LuviaCalc) return;
    window.LuviaCalc = true;
    function init(root) {
      if (root.__lvInit) return;
      root.__lvInit = true;
      var price = (parseInt(root.getAttribute('data-price'), 10) || 0) / 100;
      var cycles = parseFloat(root.getAttribute('data-cycles')) || 13;
      var years = parseFloat(root.getAttribute('data-years')) || 2;
      var itemsPer = parseFloat(root.getAttribute('data-items')) || 20;
      var fmt;
      try {
        fmt = new Intl.NumberFormat(root.getAttribute('data-locale') || 'en', { style: 'currency', currency: root.getAttribute('data-currency') || 'USD', maximumFractionDigits: 0 });
      } catch (e) { fmt = { format: function (n) { return '$' + Math.round(n); } }; }
      var spendIn = root.querySelector('[data-in="spend"]');
      var pairsIn = root.querySelector('[data-in="pairs"]');
      function out(name, v) { var el = root.querySelector('[data-out="' + name + '"]'); if (el) el.textContent = v; }
      function fill(input) {
        var min = parseFloat(input.min), max = parseFloat(input.max), v = parseFloat(input.value);
        input.style.setProperty('--p', ((v - min) / (max - min) * 100) + '%');
      }
      var shownSaved = null;
      function animateTo(target) {
        var el = root.querySelector('[data-out="saved"]');
        if (!el) return;
        var from = shownSaved === null ? target : shownSaved;
        shownSaved = target;
        var start = null;
        function tick(t) {
          if (!start) start = t;
          var p = Math.min((t - start) / 450, 1);
          var v = from + (target - from) * (1 - Math.pow(1 - p, 3));
          el.textContent = fmt.format(Math.max(0, v));
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }
      function calc() {
        var spend = parseFloat(spendIn.value), pairs = parseInt(pairsIn.value, 10);
        fill(spendIn); fill(pairsIn);
        var disp = spend * cycles * years;
        var ours = pairs * price;
        var saved = disp - ours;
        var payback = spend > 0 ? Math.ceil(ours / spend) : 0;
        out('spend', fmt.format(spend));
        out('pairs', pairs + ' pairs');
        out('disp', fmt.format(disp));
        out('ours', fmt.format(ours));
        out('payback', '~' + payback);
        out('items', Math.round(itemsPer * cycles * years).toLocaleString());
        animateTo(saved);
      }
      spendIn.addEventListener('input', calc);
      pairsIn.addEventListener('input', calc);
      calc();
    }
    function scan(r) { (r || document).querySelectorAll('[data-lv-calc]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luvia-layers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.LuviaReveal) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function count(el) {
      var end = parseFloat(el.getAttribute('data-lv-count')) || 0;
      if (reduce) { el.textContent = end; return; }
      var start = null, dur = 1300;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1);
        el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    function show(el) { el.classList.add('is-visible'); el.querySelectorAll('[data-lv-count]').forEach(count); }
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.18 }) : null;
    function scan(root) {
      (root || document).querySelectorAll('[data-lv-reveal]:not(.lv-ready)').forEach(function (el) {
        if (io && !reduce) { el.classList.add('lv-ready'); io.observe(el); } else { show(el); }
      });
    }
    window.LuviaReveal = { scan: scan };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  (function () {
    if (window.LuviaLayers) return;
    window.LuviaLayers = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function init(root) {
      if (root.__lvInit) return;
      root.__lvInit = true;
      var sheets = root.querySelectorAll('.lv-lay__sheet');
      var items = root.querySelectorAll('.lv-lay__item');
      var btns = root.querySelectorAll('.lv-lay__btn');
      var current = 0, timer = null, userTouched = false;
      function set(i) {
        current = i;
        root.classList.add('has-active');
        sheets.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
        btns.forEach(function (b, k) { b.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      }
      function stop() { userTouched = true; if (timer) { clearInterval(timer); timer = null; } }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { stop(); set(parseInt(b.getAttribute('data-index'), 10)); });
        b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { stop(); set(parseInt(b.getAttribute('data-index'), 10)); } });
      });
      if (!reduce && sheets.length > 1 && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !userTouched && !timer) {
              timer = setInterval(function () { set((current + 1) % sheets.length); }, 3600);
            } else if (!en.isIntersecting && timer) { clearInterval(timer); timer = null; }
          });
        }, { threshold: 0.4 }).observe(root);
      }
      set(0);
    }
    function scan(r) { (r || document).querySelectorAll('[data-lv-layers]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { scan(); }); } else { scan(); }
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-lv-layers]');
      if (!root) return;
      var btn = e.target.querySelector('.lv-lay__btn');
      if (btn) btn.click();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
